// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._26fVL{-webkit-column-gap:16px;-moz-column-gap:16px;column-gap:16px;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;margin:0}._26fVL ._1-_aK,._26fVL ._1g6of{-ms-flex:1 1 108px;flex:1 1 108px}._26fVL ._3p7S0{-ms-flex:0 0 131px;flex:0 0 131px}", ""]);
// Exports
exports.locals = {
	"dateOfBirth": "_26fVL",
	"day": "_1-_aK",
	"year": "_1g6of",
	"month": "_3p7S0"
};
module.exports = exports;
